
const periods = {
  SEVEN: 7,
  FIFTEEN: 15,
  THIRTY: 30,
  PERSONALIZED: 0,
};

export default periods;
